<div class="divider"><span class="divider-name">{{title}}</span><span class="line"></span></div>
